import acceptCheck from '../../../assets/images/icons/accept-check.svg';
import addPlus from '../../../assets/images/icons/add-plus.svg';
import addUserPlus from '../../../assets/images/icons/add-user-plus.svg';
import announcements from '../../../assets/images/icons/announcements.svg';
import applibrary from '../../../assets/images/icons/app-library.svg';
import archive from '../../../assets/images/icons/archive.svg';
import arrowDown from '../../../assets/images/icons/arrow-down.svg';
import arrowLeft from '../../../assets/images/icons/arrow-left.svg';
import arrowRight from '../../../assets/images/icons/arrow-right.svg';
import arrowUp from '../../../assets/images/icons/arrow-up.svg';
import assignmentPending from '../../../assets/images/icons/assignment-pending.svg';
import attachedFiles from '../../../assets/images/icons/attached-files.svg';
import automatic from '../../../assets/images/icons/automatic.svg';
import automaticAssignment from '../../../assets/images/icons/automatic-assignment.svg';
import blankPage from '../../../assets/images/icons/blank-page.svg';
import blog from '../../../assets/images/icons/blog.svg';
import blogauthors from '../../../assets/images/icons/blogauthors.svg';
import breadcrumbArrowSmall from '../../../assets/images/icons/breadcrumb-arrow-small.svg';
import breadcrumbSlash from '../../../assets/images/icons/breadcrumb-slash.svg';
import calendar from '../../../assets/images/icons/calendar.svg';
import categories from '../../../assets/images/icons/categories.svg';
import chatBubbles from '../../../assets/images/icons/chat-bubbles.svg';
import clearButton from '../../../assets/images/icons/clear-button.svg';
import closedLock from '../../../assets/images/icons/closed-lock.svg';
import closeAll from '../../../assets/images/icons/close_all.svg';
import comments from '../../../assets/images/icons/comments.svg';
import commentReply from '../../../assets/images/icons/comment-reply.svg';
import configFile from '../../../assets/images/icons/config-file.svg';
import connectBlocks from '../../../assets/images/icons/connect-blocks.svg';
import contactsPhonebook from '../../../assets/images/icons/contacts-phonebook.svg';
import deArchive from '../../../assets/images/icons/de-archive.svg';
import copyPaste from '../../../assets/images/icons/copy-paste.svg';
import declineCross from '../../../assets/images/icons/decline-cross.svg';
import deleteTrashcan from '../../../assets/images/icons/delete-trashcan.svg';
import deleteXSmall from '../../../assets/images/icons/delete-x-small.svg';
import depublish from '../../../assets/images/icons/depublish-page.svg';
import editPage from '../../../assets/images/icons/edit-page.svg';
import editPencil from '../../../assets/images/icons/edit-pencil.svg';
import editCirclePencil from '../../../assets/images/icons/edit_circle_pencil.svg';
import enterTeamroomArrow from '../../../assets/images/icons/enter-teamroom-arrow.svg';
import eraser from '../../../assets/images/icons/eraser.svg';
import extendedContent from '../../../assets/images/icons/extended-content.svg';
import externalLinkArrow from '../../../assets/images/icons/external-link-arrow.svg';
import faq from '../../../assets/images/icons/faq.svg';
import favouriteHeart from '../../../assets/images/icons/favourite-heart.svg';
import feedbackError from '../../../assets/images/icons/feedback-error.svg';
import feedbackPositiveCheck from '../../../assets/images/icons/feedback-positive-check.svg';
import fileDefault from '../../../assets/images/icons/file-default.svg';
import fileExcel from '../../../assets/images/icons/file-excel.svg';
import fileIcal from '../../../assets/images/icons/file-ical.svg';
import filePdf from '../../../assets/images/icons/file-pdf.svg';
import filePicture from '../../../assets/images/icons/file-picture.svg';
import filePowerPoint from '../../../assets/images/icons/file-power-point.svg';
import filesShared from '../../../assets/images/icons/files-shared.svg';
import fileSound from '../../../assets/images/icons/file-sound.svg';
import fileText from '../../../assets/images/icons/file-text.svg';
import fileVcard from '../../../assets/images/icons/file-vcard.svg';
import fileVideo from '../../../assets/images/icons/file-video.svg';
import fileWord from '../../../assets/images/icons/file-word.svg';
import fileZip from '../../../assets/images/icons/file-zip.svg';
import form from '../../../assets/images/icons/form.svg';
import forum from '../../../assets/images/icons/forum.svg';
import hamburgerMenu from '../../../assets/images/icons/hamburger-menu.svg';
import homeHouse from '../../../assets/images/icons/home-house.svg';
import hourGlass from '../../../assets/images/icons/hourglass.svg';
import infobox from '../../../assets/images/icons/infobox.svg';
import infoMessage from '../../../assets/images/icons/info-message.svg';
import interfaces from '../../../assets/images/icons/interfaces.svg';
import internalLinkArrow from '../../../assets/images/icons/internal-link-arrow.svg';
import inviteUnknownUser from '../../../assets/images/icons/invite-unknown-user.svg';
import keyboard from '../../../assets/images/icons/keyboard.svg';
import landscape from '../../../assets/images/icons/landscape.svg';
import latestAdditions from '../../../assets/images/icons/latest-additions.svg';
import leaveTeamroomArrow from '../../../assets/images/icons/leave-teamroom-arrow.svg';
import location from '../../../assets/images/icons/location.svg';
import mailEnvelope from '../../../assets/images/icons/mail-envelope.svg';
import members from '../../../assets/images/icons/members.svg';
import moreMenu from '../../../assets/images/icons/more_menu.svg';
import move from '../../../assets/images/icons/move.svg';
import moveDown from '../../../assets/images/icons/move-down.svg';
import moveUp from '../../../assets/images/icons/move-up.svg';
import observeEye from '../../../assets/images/icons/observe-eye.svg';
import organisation from '../../../assets/images/icons/organisation.svg';
import observationInherited from '../../../assets/images/icons/observation-inherited.svg';
import observationNotWanted from '../../../assets/images/icons/observation-not-wanted.svg';
import observationTree from '../../../assets/images/icons/observation-tree.svg';
import openAll from '../../../assets/images/icons/open_all.svg';
import pageList from '../../../assets/images/icons/page_list.svg';
import pageBack from '../../../assets/images/icons/page-back.svg';
import personalMessages from '../../../assets/images/icons/notifications-bell.svg';
import phone from '../../../assets/images/icons/phone.svg';
import portrait from '../../../assets/images/icons/portrait.svg';
import printer from '../../../assets/images/icons/printer.svg';
import process2 from '../../../assets/images/icons/process2.svg';
import publish from '../../../assets/images/icons/publish-page.svg';
import publishLightsGreen from '../../../assets/images/icons/publish-lights-green.svg';
import publishLightsRed from '../../../assets/images/icons/publish-lights-red.svg';
import publishLightsYellow from '../../../assets/images/icons/publish-lights-yellow.svg';
import recommendPaperplane from '../../../assets/images/icons/recommend-paperplane.svg';
import removeUserCross from '../../../assets/images/icons/remove-user-cross.svg';
import reply from '../../../assets/images/icons/reply.svg';
import replyMessage from '../../../assets/images/icons/reply_message.svg';
import restore from '../../../assets/images/icons/restore.svg';
import results from '../../../assets/images/icons/results.svg';
import searchMagnifier from '../../../assets/images/icons/search-magnifier.svg';
import magnifierBigger from '../../../assets/images/icons/magnifier-bigger.svg';
import magnifierSmaller from '../../../assets/images/icons/magnifier-smaller.svg';
import settings from '../../../assets/images/icons/settings.svg';
import survey from '../../../assets/images/icons/survey.svg';
import skillsRibbon from '../../../assets/images/icons/skills-ribbon.svg';
import task from '../../../assets/images/icons/task.svg';
import teamroomPeople from '../../../assets/images/icons/teamroom-people.svg';
import ticket from '../../../assets/images/icons/ticket.svg';
import ticketBooking from '../../../assets/images/icons/ticket-booking.svg';
import topHeadlines from '../../../assets/images/icons/top-headlines.svg';
import topic from '../../../assets/images/icons/topic.svg';
import undo from '../../../assets/images/icons/undo.svg';
import upCircleArrowFull from '../../../assets/images/icons/up-circle-arrow-full.svg';
import upcomingEvents from '../../../assets/images/icons/upcoming-events.svg';
import userPAL from '../../../assets/images/icons/user-PAL.svg';
import video from '../../../assets/images/icons/video.svg';
import videocall from '../../../assets/images/icons/videocall.svg';
import wiki from '../../../assets/images/icons/wiki.svg';
import zoomIn from '../../../assets/images/icons/zoom-in.svg';
import zoomOut from '../../../assets/images/icons/zoom-out.svg';
import shrinkArrows from '../../../assets/images/icons/shrink-arrows.svg';
import expandArrows from '../../../assets/images/icons/expand-arrows.svg';
import resourcesList from '../../../assets/images/icons/resources-list.svg';
import graphicStructure from '../../../assets/images/icons/graphic-structure.svg';
import imageGallery from '../../../assets/images/icons/image-gallery.svg';
import analysis from '../../../assets/images/icons/analysis.svg';
import connections from '../../../assets/images/icons/connections.svg';
import belongsTo from '../../../assets/images/icons/belongs-to.svg';
import contains from '../../../assets/images/icons/contains.svg';
import continuing from '../../../assets/images/icons/continuing.svg';
import executes from '../../../assets/images/icons/executes.svg';
import isExecuted from '../../../assets/images/icons/is_executed.svg';
import isResponsible from '../../../assets/images/icons/is_responsible.svg';
import participates from '../../../assets/images/icons/participates.svg';
import predecessor from '../../../assets/images/icons/predecessor.svg';
import related from '../../../assets/images/icons/related.svg';
import successor from '../../../assets/images/icons/successor.svg';
import underParticipation from '../../../assets/images/icons/under-participation.svg';
import underResponsibility from '../../../assets/images/icons/under-responsibility.svg';
import upArrow from '../../../assets/images/icons/up-arrow.svg';
import searchHit from '../../../assets/images/icons/search-hit.svg';
import folderClosed from '../../../assets/images/icons/folder-closed.svg';
import folderOpen from '../../../assets/images/icons/folder-open.svg';
import downloadArrow from '../../../assets/images/icons/download-arrow.svg';
import rssFeed from '../../../assets/images/icons/rss.svg';
import click from '../../../assets/images/icons/click.svg';
import activity from '../../../assets/images/icons/activity.svg';
import sortArrowBoth from '../../../assets/images/icons/sort-arrow-both.svg';
import sortArrowUp from '../../../assets/images/icons/sort-arrow-up.svg';
import sortArrowDown from '../../../assets/images/icons/sort-arrow-down.svg';
import timeboxUnset from '../../../assets/images/icons/timebox-unset.svg';
import signLanguage from '../../../assets/images/icons/sign-language.svg';
import simpleLanguage from '../../../assets/images/icons/simple-language.svg';
import latestRegistrations from '../../../assets/images/icons/latest-registrations.svg';
import template from '../../../assets/images/icons/template.svg';
import bookmark from '../../../assets/images/icons/bookmark.svg';

import { BlockType, ElementType } from '../../../types/api/ElementType';

/**
 * Map ElementTypes to specific Icons.
 * Used for automatic Widget-Icons mapping.
 *
 * note: newer Widgets use direct mapping, no need to define them here.
 */
export const ElementypesToIcons = new Map<ElementType | BlockType, string>([
  [ElementType.attachedfiles, attachedFiles],
  [ElementType.pagesettings, settings],
  [ElementType.personalmessages, personalMessages],
  [ElementType.portaladministration, settings],
  [ElementType.systemadministration, settings],
  [ElementType.topheadlines, topHeadlines],
  [ElementType.helprichtext, infoMessage],
  [BlockType.teamroommemberrequests, enterTeamroomArrow],
  [BlockType.areamembers, members],
  [BlockType.usersearch, searchMagnifier],
  [BlockType.contentsearch, searchMagnifier],
  [BlockType.editorialdashboard, searchMagnifier],
  [BlockType.currentannouncementsinbox, announcements],
]);

/**
 * Icons we use directly.
 */
export const Icons = {
  ANNOUNCEMENTS: announcements,
  APP_LIBRARY: applibrary,
  ACCEPT_CHECK: acceptCheck,
  ACTIVITY: activity,
  ADD_PLUS: addPlus,
  ADD_USER_PLUS: addUserPlus,
  ARCHIVE: archive,
  ARROW_DOWN: arrowDown,
  ARROW_LEFT: arrowLeft,
  ARROW_RIGHT: arrowRight,
  ARROW_UP: arrowUp,
  ASSIGNMENT_PENDING: assignmentPending,
  ATTACHED_FILES: attachedFiles,
  AUTOMATIC: automatic,
  AUTOMATIC_ASSIGNMENT: automaticAssignment,
  BLANK_PAGE: blankPage,
  BLOG: blog,
  BLOG_AUTHORS: blogauthors,
  BREADCRUMB_ARROW_SMALL: breadcrumbArrowSmall,
  BREADCRUMB_SLASH: breadcrumbSlash,
  CALENDAR: calendar,
  CHAT_BUBBLE: chatBubbles,
  CLEAR_BUTTON: clearButton,
  CLICK: click,
  CLOSED_LOCK: closedLock,
  CLOSE_ALL: closeAll,
  COMMENTS: comments,
  COMMENT_REPLY: commentReply,
  CONFIG_FILE: configFile,
  CONNECT_BLOCKS: connectBlocks,
  CONTACTS_PHONEBOOK: contactsPhonebook,
  COPY_PASTE: copyPaste,
  CONNECTIONS: connections,
  DECLINE_CROSS: declineCross,
  DELETE_TRASHCAN: deleteTrashcan,
  DELETE_X_SMALL: deleteXSmall,
  DEPUBLISH: depublish,
  DOWNLOAD_ARROW: downloadArrow,
  EDIT_PAGE: editPage,
  EDIT_PENCIL: editPencil,
  EDIT_CIRCLE_PENCIL: editCirclePencil,
  ENTER_TEAMROOM_ARROW: enterTeamroomArrow,
  ERASER: eraser,
  EXTERNAL_LINK_ARROW: externalLinkArrow,
  EXTENDED_CONTENT: extendedContent,
  FAQ: faq,
  FAVOURITE_HEART: favouriteHeart,
  FEEDBACK_ERROR: feedbackError,
  FEEDBACK_POSITIVE_CHECK: feedbackPositiveCheck,
  FILE_DEFAULT: fileDefault,
  FILE_EXCEL: fileExcel,
  FILE_ICAL: fileIcal,
  FILE_PDF: filePdf,
  FILE_PICTURE: filePicture,
  FILE_POWER_POINT: filePowerPoint,
  FILE_SOUND: fileSound,
  FILE_TEXT: fileText,
  FILE_VCARD: fileVcard,
  FILE_VIDEO: fileVideo,
  FILE_WORD: fileWord,
  FILE_ZIP: fileZip,
  FILES_SHARED: filesShared,
  FORM: form,
  FORUM: forum,
  GRAPHIC_STRUCTURE: graphicStructure,
  HAMBURGER_MENU: hamburgerMenu,
  HOME_HOUSE: homeHouse,
  HOUR_GLASS: hourGlass,
  INTERFACES: interfaces,
  INTERNAL_LINK_ARROW: internalLinkArrow,
  INVITE_UNKNOWN_USER: inviteUnknownUser,
  IMAGE_GALLERY: imageGallery,
  INFO_BOX: infobox,
  INFO_MESSAGE: infoMessage,
  PAGE_BACK: pageBack,
  KEYBOARD: keyboard,
  LATEST_ADDITIONS: latestAdditions,
  LANDSCAPE: landscape,
  LEAVE_TEAMROOM_ARROW: leaveTeamroomArrow,
  LOCATION: location,
  MAIL_ENVELOPE: mailEnvelope,
  MEMBERS: members,
  MORE_MENU: moreMenu,
  MOVE: move,
  MOVE_DOWN: moveDown,
  MOVE_UP: moveUp,
  ORGANISATION: organisation,
  OBSERVE_EYE: observeEye,
  OBSERVATION_INHERITED: observationInherited,
  OBSERVATION_NOT_WANTED: observationNotWanted,
  OBSERVATION_TREE: observationTree,
  OPEN_ALL: openAll,
  PAGE_LIST: pageList,
  PHONE: phone,
  PORTRAIT: portrait,
  PRINTER: printer,
  PROCESS2: process2,
  PUBLISH: publish,
  PUBLISH_LIGHTS_GREEN: publishLightsGreen,
  PUBLISH_LIGHTS_RED: publishLightsRed,
  PUBLISH_LIGHTS_YELLOW: publishLightsYellow,
  RECOMMEND_PAPERPLANE: recommendPaperplane,
  REMOVE_USER_CROSS: removeUserCross,
  RESOURCES_LIST: resourcesList,
  REPLY: reply,
  REPLY_MESSAGE: replyMessage,
  RESTORE: restore,
  RESULTS: results,
  SKILLS_RIBBON: skillsRibbon,
  SEARCH_MAGNIFIER: searchMagnifier,
  MAGNIFIER_BIGGER: magnifierBigger,
  MAGNIFIER_SMALLER: magnifierSmaller,
  SETTINGS: settings,
  SURVEY: survey,
  TASK: task,
  TEAMROOM_PEOPLE: teamroomPeople,
  TICKET: ticket,
  TICKET_BOOKING: ticketBooking,
  TIMEBOX_UNSET: timeboxUnset,
  TOPIC: topic,
  UNDO: undo,
  UP_CIRCLE_ARROW_FULL: upCircleArrowFull,
  USER_PAL: userPAL,
  VIDEOCALL: videocall,
  WIKI: wiki,
  ZOOM_IN: zoomIn,
  ZOOM_OUT: zoomOut,
  SHRINK_ARROWS: shrinkArrows,
  EXPAND_ARROWS: expandArrows,
  ANALYSIS: analysis,
  CATEGORIES: categories,
  UPCOMING_EVENTS: upcomingEvents,
  UP_ARROW: upArrow,
  SEARCH_HIT: searchHit,
  PAGE_TO_PAGE_ROLE_BELONGS_TO: belongsTo,
  PAGE_TO_PAGE_ROLE_CONTAINS: contains,
  PAGE_TO_PAGE_ROLE_CONTINUING: continuing,
  PAGE_TO_PAGE_ROLE_EXECUTES: executes,
  PAGE_TO_PAGE_ROLE_IS_EXECUTED: isExecuted,
  PAGE_TO_PAGE_ROLE_IS_RESPONSIBLE: isResponsible,
  PAGE_TO_PAGE_ROLE_PARTICIPATES: participates,
  PAGE_TO_PAGE_ROLE_PREDECESSOR: predecessor,
  PAGE_TO_PAGE_ROLE_RELATED: related,
  PAGE_TO_PAGE_ROLE_SUCCESSOR: successor,
  PAGE_TO_PAGE_ROLE_UNDER_PARTICIPATION: underParticipation,
  PAGE_TO_PAGE_ROLE_UNDER_RESPONSIBILITY: underResponsibility,
  VIDEO: video,
  FOLDER_CLOSED: folderClosed,
  FOLDER_OPEN: folderOpen,
  RSS_FEED: rssFeed,
  SORT_ARROW_BOTH: sortArrowBoth,
  SORT_ARROW_UP: sortArrowUp,
  SORT_ARROW_DOWN: sortArrowDown,
  UN_ARCHIVE: deArchive,
  SIGN_LANGUAGE: signLanguage,
  SIMPLE_LANGUAGE: simpleLanguage,
  LATEST_REGISTRATIONS: latestRegistrations,
  TEMPLATE: template,
  BOOKMARK: bookmark,
};
